var POPOVER_DATA_TESTIDS = {
  dialogContent: "mntl-popover-dialog-content",
  dialogFooter: "mntl-popover-dialog-footer",
  dialogHeaderContainer: "mntl-popover-dialog-header-container",
  dialogHeader: "mntl-popover-dialog-header"
};
var POPOVER_ERROR_MESSAGES = {
  POPOVER_REQUIRES_ARIA_WITHOUT_STRING_HEADER: 'Popover component with non-string `header` should have "popoverAriaLabel" defined',
  POPOVER_REQUIRES_DISMISS_BUTTON_OR_DISMISS_OUTSIDE_CLICK: "Popover cannot be dismissed since `hideDismissButton = true` and `closeOnOutsideClick = false"
};

export { POPOVER_DATA_TESTIDS, POPOVER_ERROR_MESSAGES };
